import { CartUpdateEvent, ThemeEvents } from '@theme/events';

let syncing = false;

function cartUpdateUrl() {
  return (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
}

function cartJsonUrl() {
  return (window.Theme && window.Theme.routes && window.Theme.routes.cart_url
    ? `${window.Theme.routes.cart_url}.js`
    : '/cart.js');
}

function sectionIdsToUpdate() {
  const sectionIds = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((node) => {
    if (node.dataset.sectionId) sectionIds.push(node.dataset.sectionId);
  });
  return sectionIds;
}

function postCartUpdates(updates) {
  const keys = Object.keys(updates);
  if (!keys.length) return Promise.resolve(null);

  syncing = true;
  return fetch(cartUpdateUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      updates,
      sections: sectionIdsToUpdate().join(','),
      sections_url: window.location.pathname,
    }),
  })
    .then((response) => response.json())
    .then((payload) => {
      if (!payload || payload.errors) return null;
      document.dispatchEvent(
        new CartUpdateEvent(payload, 'leaves-cart-kit-qty', {
          source: 'leaves-cart-kit-qty',
          itemCount: payload.item_count,
          sections: payload.sections,
        })
      );
      return payload;
    })
    .catch(() => null)
    .finally(() => {
      syncing = false;
    });
}

/** Patio kit − / + control (text buttons; theme SVG qty icons were invisible in cart). */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const btn = target.closest('[data-leaves-kit-qty-delta]');
  if (!btn) return;
  const root = btn.closest('[data-leaves-kit-qty]');
  if (!root) return;
  const input = root.querySelector('.leaves-kit-qty__input');
  if (!(input instanceof HTMLInputElement)) return;

  event.preventDefault();
  const delta = Number(btn.getAttribute('data-leaves-kit-qty-delta')) || 0;
  const line = Number(input.getAttribute('data-cart-line'));
  if (!line) return;

  const current = Number.parseInt(input.value, 10);
  const next = Math.max(0, (Number.isFinite(current) ? current : 1) + delta);
  input.value = String(next);

  btn.dispatchEvent(
    new CustomEvent(ThemeEvents.quantitySelectorUpdate, {
      bubbles: true,
      detail: {
        quantity: next,
        cartLine: line,
      },
    })
  );
});

/**
 * Trash next to kit qty: remove the whole patio kit (parent + every linked part).
 * Flat kits only share _itemKey / _parentKey, so cart/change on the parent alone leaves orphans.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const btn = target.closest('[data-leaves-kit-remove]');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();
  if (syncing || btn.hasAttribute('aria-busy')) return;

  const itemKey = (btn.getAttribute('data-leaves-item-key') || '').trim();
  const lineKey = (btn.getAttribute('data-leaves-line-key') || '').trim();
  if (!itemKey && !lineKey) return;

  btn.setAttribute('aria-busy', 'true');
  btn.setAttribute('disabled', 'true');

  fetch(cartJsonUrl(), { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => {
      if (!cart || !Array.isArray(cart.items)) return null;
      const updates = {};
      cart.items.forEach((line) => {
        const props = line.properties || {};
        const isParent = (lineKey && line.key === lineKey) || (itemKey && props._itemKey === itemKey);
        const isChild =
          (itemKey && props._parentKey === itemKey) ||
          (lineKey && linkedParentKey(line) === lineKey);
        if (isParent || isChild) updates[line.key] = 0;
      });
      return postCartUpdates(updates);
    })
    .finally(() => {
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('disabled');
    });
});

function linkedParentKey(item) {
  const rel = item && item.parent_relationship;
  if (!rel) return '';
  return rel.parent_key || (rel.parent && rel.parent.key) || '';
}

function isKitChild(child, parent) {
  if (!child || !parent || child.key === parent.key) return false;
  const parentItemKey = (parent.properties && parent.properties._itemKey) || '';
  const childParentKey = (child.properties && child.properties._parentKey) || '';
  if (parentItemKey && childParentKey === parentItemKey) return true;
  const linked = linkedParentKey(child);
  return Boolean(linked && linked === parent.key);
}

function desiredChildQty(child, parentQty) {
  if (parentQty <= 0) return 0;
  const unit = Number(child.properties && child.properties._kitUnitQty);
  if (!Number.isInteger(unit) || unit < 1) return null;
  return unit * parentQty;
}

document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  if (syncing) return;
  const cart = event.detail && event.detail.resource;
  if (!cart || !Array.isArray(cart.items)) return;

  const updates = {};
  cart.items.forEach((parent) => {
    const props = parent.properties || {};
    if (props._leavesKit !== 'patio') return;
    const parentQty = Number(parent.quantity) || 0;
    cart.items.forEach((child) => {
      if (!isKitChild(child, parent)) return;
      const next = desiredChildQty(child, parentQty);
      if (next == null || Number(child.quantity) === next) return;
      updates[child.key] = next;
    });
  });

  postCartUpdates(updates);
});
